import BottomSheet from "@/design-system/BottomSheet/BottomSheet";
import { useScrollLock } from "@/hooks/useScrollLock";
import type { EvolutionPickerSelection } from "@repo/shared/evolutions";

import {
  EvolutionFilterData,
  IncludeExcludeEvolutions,
} from "./EvolutionsBuilder/components/IncludeExcludeEvolutions/IncludeExcludeEvolutions";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onApply: (data: EvolutionFilterData) => void;
  activeFilter: EvolutionPickerSelection;
  handleSelectActiveFilter: (filter: EvolutionPickerSelection) => void;
  initialIncludedEvolutions?: number[];
  initialMustIncludeEvolutions?: number[];
  showExpired?: boolean;
  ignoreExcludedByDefault?: boolean;
}

export const EvolutionsPickerBottomSheet = ({
  isOpen,
  onClose,
  onApply,
  initialIncludedEvolutions,
  initialMustIncludeEvolutions,
  activeFilter,
  handleSelectActiveFilter,
  showExpired,
  ignoreExcludedByDefault,
}: Props) => {
  useScrollLock(true);
  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      className="bg-new-gray-900 shadow-2xl"
    >
      <IncludeExcludeEvolutions
        onApply={(data) => {
          onApply(data);
          onClose();
        }}
        onClose={onClose}
        initialIncludedEvolutions={initialIncludedEvolutions}
        initialMustIncludeEvolutions={initialMustIncludeEvolutions}
        activeFilter={activeFilter}
        handleSelectActiveFilter={handleSelectActiveFilter}
        showExpired={showExpired}
        ignoreExcludedByDefault={ignoreExcludedByDefault}
      />
    </BottomSheet>
  );
};
